import CurrentUserPhoto from '@/components/shared/CurrentUserPhoto.vue'
import Comment from '../Comment.vue'
import { mapState } from 'vuex'
import CommentInput from '@/components/post/CommentInput.vue'
import { nextTick, ref } from 'vue'
import ChevronDoubleDown from 'vue-material-design-icons/ChevronDoubleDown.vue'
import VLoadSpinner from '../../shared/VLoadSpinner.vue'
import swipe from '../Swipe'

const top = ref(200)
const opacity = ref('1')

export default {
  name: 'Comments',
  components: { CommentInput, CurrentUserPhoto, Comment, ChevronDoubleDown, VLoadSpinner },
  data() {
    return {
      newComment: '',
      editor: null,
      characterCount: 0,
      replyToComment: {},
      commentToEdit: {},
      posting: false,
      top: top,
      opacity: opacity
    }
  },
  props: {
    communityId: {
      type: String,
      required: true
    },
    postId: {
      type: String,
      required: true
    },
    enableEdit: {
      type: Boolean,
      required: false,
      default: true
    },
    isAdminPage: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  async mounted() {
    window.addEventListener('resize', this.windowEvent)
    this.windowEvent()
    top.value = 200
    opacity.value = '1'
    swipe.setSwipe(top,
      this.closeCommentSection,
      this.$refs['target'],
      this.$refs['container'],
      200,
      -20
    )
    await nextTick()
    await this.$store.dispatch('getComments', this.postId)
  },
  beforeDestroy() {
    this.$store.dispatch('deleteCommentsFromState', this.postId)
    window.removeEventListener('resize', this.windowEvent)
    document.body.classList.remove('noscroll', true)
  },
  methods: {
    cancelReply() {
      this.replyToComment = {}
      this.newComment = ''
    },
    async editComment(comment, charCount) {
      if (charCount > 500 || charCount < 1) {
        return
      }
      this.posting = true

      await this.$store.dispatch('editComment', {
        comment: { id: this.commentToEdit.id, comment: comment }
      })
      this.commentToEdit = {}
      this.posting = false
    },
    async startEdit(item) {
      this.replyToComment = {}
      this.commentToEdit = {}
      this.focusTextEditor()
      await nextTick()
      this.commentToEdit = this.$sanitizeHTML(this.$decodeHTML(item))
    },
    cancelEdit() {
      this.commentToEdit = {}
      this.newComment = ''
    },
    async sendComment(comment, charCount, item) {
      if (charCount > 500 || charCount < 1) {
        return
      }
      this.posting = true

      this.newComment = ''
      if (this.replyToComment.id) {
        await this.$store.dispatch('addComment', {
          postId: this.postId,
          comment: comment,
          parentId: this.replyToComment.parentId ? this.replyToComment.parentId : this.replyToComment.id
        })
      } else {
        await this.$store.dispatch('addComment', {
          postId: this.postId,
          comment: comment
        })
      }
      this.replyToComment = {}
      this.posting = false
    },
    async startReply(item) {
      if (item.parentId) {
        this.addReplyMention(item.author)
      } else {
        this.newComment = ''
      }
      this.focusTextEditor()
      this.replyToComment = item
      this.commentToEdit = {}
    },
    addReplyMention(author) {
      this.newComment =
          `<p><span data-type="mention" \
class="mention" data-id="${author.id}" \
data-label="${author.firstName} ${author.lastName}" \
 contenteditable="false">@${author.firstName} ${author.lastName} \
</span>&nbsp  </p>`
    },
    closeCommentSection() {
      this.$emit('close-comments')
    },
    windowEvent() {
      var body = document.body
      if (window.innerWidth <= 600) {
        body.classList.toggle('noscroll', true)
      } else {
        body.classList.remove('noscroll', true)
      }
    },
    focusTextEditor() {
      try {
        document.querySelector(`#input${this.postId} .ProseMirror`).focus()
      } catch (e) {}
    }
  },

  computed: {
    ...mapState({
      userId: state => state.user.user.id,
      answers: state => state.comment.comments,
      comments: state => state.comment.comments
    }),
    users() {
      return this.$store.getters.userByCommunity[this.communityId]
    }
  }
}
